import React, {useState, useEffect, useRef} from 'react';
import Aux from '../../hoc/Aux/Aux';
import ProjectPlaceholder from '../../components/UI/Placeholder/ProjectPlaceholder/ProjectPlaceholder'
import Gallery from '../../components/Gallery/Gallery';
import GalleryItem from '../../components/Gallery/GalleryItem/GalleryItem';
import ShareButton from '../../components/UI/SocialShareButton/SocialShareButton';
import thumbnailPlaceholder from '../../assets/images/project-thumbnail-placeholder.jpg';
import {QRCodeScanner} from "../../components/QRCodeScanner";
import {Row, Col, Button, ModalHeader, Modal, ModalBody, ModalFooter} from 'reactstrap';
import axios from '../../axios-base';
import moment from 'moment';
import SMSVote from "./SMSVote";
import VotePlaceholder from './VotePlaceholder';
import {Helmet} from "react-helmet";
import {useParams} from 'react-router-dom';
import ProgressBar from "../../components/UI/ProgressBar/ProgressBar";
import classes from "../ProjectList/ProjectListItem/ProjectListItem.module.scss";
import {determineVotes} from "../../shared/VoteEvaluatorFunctions"
import Badge from "../../components/UI/Badges/Badge";
import icQRCode from '../../assets/images/cassiopeia-icon-qr-code.svg';
import image1 from '../../assets/images/cassiopeia-give-away-sample-1.jpg';
import qrCodeInvalid from '../../assets/images/cassiopeia-scan-invalid.svg';
import successSound from '../../assets/images/cassiopeia-sound-confetti.mp3';
import failureSound from '../../assets/images/cassiopeia-sound-wahwahwaaa.mp3';
import Confetti from 'react-confetti';
import Cookies from "js-cookie";
import ReactJoyride, {STATUS} from "react-joyride";
import styles from "../ProjectList/ProjectList.module.scss";

function Project(props){

    const [loadedPost, setLoadedPost] = useState(null);
    const [voteCount, setVoteCount] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [scannedData, setScannedData] = useState("");
    const [scanMessage, setScanMessage] = useState("")
    const [selectedImage, setSelectedImage] = useState(null);
    const [showConfetti, setShowConfetti] = useState(false);
    const [steps, setSteps] = useState([]);

    const images = [image1];
    const audioRef = useRef(null);
    const playSound = (sound) => {
        if (!audioRef.current) {
            audioRef.current = new Audio(sound); // Create audio instance if it doesn't exist
        }
        audioRef.current.src = sound; // Set the correct sound file
        audioRef.current.play();
    };

    const toggleModal = () => {
        setScannedData("");
        setIsModalOpen(!isModalOpen);
    };

    const handleScanSuccess = (data) => {
        const setSuccessState = () => {
            playSound(successSound);
            setScannedData(data);
                setScanMessage("An dieser Stelle könnte ihre Vor-Ort-Aktion zu sehen sein!");
            const randomImage = images[Math.floor(Math.random() * images.length)];
            setSelectedImage(randomImage);
            setShowConfetti(true);
            Cookies.set('cassiopeia_funding-scan', true, { expires: 1 });
        };

        const setErrorState = (message, image) => {
            playSound(failureSound);
            setScannedData(message);
            setScanMessage(message);
            setSelectedImage(image);
        };

        if (data === 'https://www.spendenkick.de') {
            setSuccessState();
        } else {
            setErrorState('Ungültiger QR-Code', qrCodeInvalid);
        }
    };

    let { id } = useParams();
    useEffect(() => {
        axios.get(`projects/${id}`)
            .then(({data}) => {
                let votes = determineVotes(data.voteCount, props.votingPhases);
                setLoadedPost(data)
                setVoteCount(votes);
                setSteps([
                    {
                        target: '.joyride-vote-progress',
                        content: `Hier sehen Sie die Zahl der gesammelten Stimmen des Projekts welches Sie unterstützen möchten.`,
                        disableBeacon: true,
                        placement: 'top'
                    },
                    {
                        target: '.form-control',
                        content: `Hier können Sie mit Hilfe eines per SMS erhaltenen Codes eine Stimme für dieses Projekt abgeben.`,
                        disableBeacon: true,
                        placement: 'top'
                    },
                    {
                        target: '.joyride-sms-request',
                        content: `Wenn Sie noch keinen Code per SMS angefordert haben, können Sie das hier kostenlos tun.`,
                        disableBeacon: true,
                        placement: 'top'
                    },
                    {
                        target: '.joyride-vote-btn',
                        content: `Sobald Sie einen gültigen Code eingegeben haben, können über diese Schaltfläche Ihre Stimme abgeben.`,
                        disableBeacon: true,
                        placement: 'top'
                    },
                    {
                        target: '.joyride-qr-btn',
                        content: `Zusätzlich zur Stimmabgabe können Abstimmende ihr Lieblingsprojekt auch über das Scannen eines QR-Codes unterstützen.`,
                        disableBeacon: true,
                        placement: 'top'
                    },
                ]);
            })
            .catch(error => {
                console.log(error);
            });
    }, [props.votingPhases, id])

        let voteComponent;
        if (loadedPost && props?.votingPhases) {
            const startDate = props.votingPhases.voteStart;
            if (!props.votingPhases.votingStarted) {
                // placeholder - prior to voting
                let text = 'Am ' + moment(startDate).format('DD.MM.') + ' geht\'s los';
                voteComponent = <VotePlaceholder text={text} />;
            } else if (props.votingPhases.votingEnded) {
                // placeholder - end of voting
                voteComponent = <VotePlaceholder text='Abstimmung ist beendet!' />;
            } else {
                // voting in progress
                if(props.balance > 0) {
                    voteComponent = <SMSVote projectCategory={loadedPost.projectCategory} {...props}/>;
                } else {
                    voteComponent = <VotePlaceholder text='Der Fördertopf ist leer'/>;
                }
            }
        }

        let project = (
            <Row className="py-3">
                <Col xs="12">
                    <ProjectPlaceholder/>
                </Col>
            </Row>
        );

        if (loadedPost) {

            project = (
                <Aux>
                    <Helmet>
                        <title>{`${process.env.REACT_APP_PROJECT_TITLE}: ${loadedPost.contestantName}`}</title>
                    </Helmet>
                    {Cookies.get('bigfoot_cookie-consent') && !Cookies.get('bigfoot_tour-projects') && <ReactJoyride
                            showProgress
                            continuous
                            steps={steps}
                            disabledScrolling
                            hideCloseButton
                            scrollDuration={800}
                            styles={{
                                options: {
                                    zIndex: 1021,
                                    primaryColor: styles.primaryColor,
                                },
                                tooltipContent: {
                                    padding: '0px'
                                }
                            }}
                            locale={{back: 'Zurück', close: 'Schließen', last: 'Letzte', next: 'Nächste', open: 'Öffnen', skip: 'Überspringen'}}
                            callback={({ status }) => {
                                if (([STATUS.FINISHED, STATUS.SKIPPED]).includes(status)) {
                                    Cookies.set('bigfoot_tour-project', true, {expires: 1});
                                }
                            }}
                            floaterProps = {{
                                disableAnimation: true,
                                disableFlip: true}} />
                    }
                    <Row className="my-3">
                        <Col xs="12" lg="5">
                            <Row className="pb-3 pt-1 position-relative">
                                <Col xs="12">
                                    {loadedPost && loadedPost.projectGallery.length ? <div className={classes.CardImage} style={{ backgroundImage: `url(${loadedPost.projectGallery[0]})` }}/> : <div className={classes.CardImage} style={{ backgroundImage: `url(${thumbnailPlaceholder})` }}/>}
                                </Col>
                                <Row className="position-absolute w-100 h-100 m-0 top-0 justify-content-end">
                                    <Badge type="isReferral" isAchieved={loadedPost.achievements.some(ach => ach.type === 'isReferral'&& ach.isAchieved)} />
                                    <Badge type="hasReferred" isAchieved={loadedPost.achievements.some(ach => ach.type === 'hasReferred'&& ach.isAchieved)} />
                                    <Badge type="whatsAppShares" isAchieved={loadedPost.achievements.some(ach => ach.type === 'whatsAppShares'&& ach.isAchieved)} />
                                    <Badge type="facebookShares" isAchieved={loadedPost.achievements.some(ach => ach.type === 'facebookShares'&& ach.isAchieved)} />
                                    <Badge type="emailShares" isAchieved={loadedPost.achievements.some(ach => ach.type === 'emailShares'&& ach.isAchieved)} />
                                    <Badge type="twitterShares" isAchieved={loadedPost.achievements.some(ach => ach.type === 'twitterShares'&& ach.isAchieved)} />
                                    {/* Add more BadgeComponent instances as needed for other badge types */}
                                </Row>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <h1 className="text-primary">{loadedPost.contestantName}</h1>
                                    <h2 className="text-dark">{loadedPost.projectTitle}</h2>

                                </Col>
                            </Row>
                            <Row className="mb-3 joyride-vote-progress">
                                <Col className="overflow-hidden">
                                    <ProgressBar
                                        cssClasses={"mt-5 mb-4"}
                                        voteCount={voteCount}
                                        threshold1={props.threshold1}
                                        threshold2={props.threshold2}
                                        fundingIncrement1={props.fundingIncrement1}
                                        fundingIncrement2={props.fundingIncrement2}
                                        projectBalance={loadedPost ? loadedPost.fundingAccount.balance : 0}
                                        bubble={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                {voteComponent}
                            </Row>
                            <Row className="my-3">
                                <Col>
                                    <Button color="dark" outline className="w-100 joyride-qr-btn" onClick={toggleModal}>
                                        <img src={icQRCode} style={{maxWidth: '20px', height: 'auto'}} alt="QR-Code scannen" className="pe-1"/>Jetzt QR-Code scannen
                                    </Button>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs="12" lg="7">
                            <Row>
                                <Col xs={{size: 12, order: 2}} lg={{order: 1}}>
                                    <h1 className="text-primary">Das ist unser Projekt</h1>
                                    <p>{loadedPost.contestantAnswer1}</p>
                                </Col>

                                <Col xs={{size: 12, order: 1}} lg={{order: 3}} className="px-0 p-md-3 mb-3">
                                    <Gallery>
                                        {loadedPost.projectGallery.map((galleryItem, index) => (
                                            <GalleryItem
                                                key={index}
                                                src={galleryItem}
                                                alt={'Galeriebild ' + index}/>
                                        ))}
                                    </Gallery>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Aux>
            )
        }

        return (
            <Aux>
                {project}
                <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
                    {showConfetti && (
                        <Confetti
                            recycle={false} // Confetti should only appear once
                            onConfettiComplete={() => setShowConfetti(false)} // Remove confetti after it's done
                        />
                    )}
                    <ModalHeader toggle={toggleModal}>Jetzt QR-Code einscannen!</ModalHeader>
                    <ModalBody>
                        {scannedData && selectedImage ? (
                            <>
                                <p>{scanMessage}</p>
                                <img className="img-fluid mb-3" src={selectedImage} alt="QR-Code-Scanner-Benachrichtigung" />
                                <p>Erfahren Sie mehr über CrowdVoting & SpendenKick mit einer <strong>kostenlose
                                    Potenzialanalyse</strong>.</p>
                                <p>Rufen Sie uns an <a className="bg-warning text-dark" href="tel:+4922167774683">0221 / 677 746 83</a><br/>oder
                                    schreiben Sie uns an <a className="bg-warning text-dark" href="mailto:info@socialvalue.de">info@socialvalue.de</a>
                                </p>
                            </>
                        ) : (
                            <QRCodeScanner onScan={handleScanSuccess}/>
                        )}
                    </ModalBody>
                </Modal>
            </Aux>
        );
}

export default Project;
